<template>
  <div class="navigatorActivityDownloaderClass">

    <NavbarComponent :loadingStatus="loading">Navigator Activity Downloader</NavbarComponent>
    <section>
      <div v-if="!loading" class="container is-fluid">
        <br>
        <nav class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Client</p>
              <p class="title">
                <div class="select">
                  <ClientsSelect :list=activityClientsList></ClientsSelect>
                </div>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Created By</p>
              <p class="title">
                <div class="select">
                  <CreatedSelect :list=activityCreatedList></CreatedSelect>
                </div>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Assigned To</p>
              <p class="title">
                <div class="select">
                  <AssignedSelect :list=activityAssignedList></AssignedSelect>
                </div>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Status</p>
              <p class="title">
                <div class="select">
                  <StatusSelect :list=activityStatusesList></StatusSelect>
                </div>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Priority</p>
              <p class="title">
                <div class="select">
                  <PrioritySelect :list=activityPrioritiesList></PrioritySelect>
                </div>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Quality</p>
              <p class="title">
                <div class="select">
                  <QualitySelect :list=activityQualitiesList></QualitySelect>
                </div>
              </p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">Download</p>
              <p class="title"> <button class="button is-dark sh" @click="DownloadActivityLog()">Download</button></p>
            </div>
          </div>
        </nav>

        <!--  
  <div class="field is-grouped is-grouped-centered">
   <div class="field extra-space">
   <label class="label">Client</label>
  <p class="control">
   <div class="select"><ClientsSelect :list=activityClientsList></ClientsSelect></div>
  </p>
  </div>
  
     <div class="field extra-space">
   <label class="label">Created By</label>
  <p class="control">
   <div class="select">   <CreatedSelect :list=activityCreatedList></CreatedSelect></div> 
  </p>
  </div>
  
      <div class="field extra-space">
   <label class="label">Assigned To </label>
  <p class="control">
   <div class="select"><AssignedSelect :list=activityAssignedList></AssignedSelect></div>
  </p>
  </div>
  
  
      <div class="field extra-space">
   <label class="label">Status</label>
  <p class="control">
  <div class="select"> <StatusSelect :list=activityStatusesList></StatusSelect>  </div>
  </p>
  </div>
  
  
     <div class="field extra-space">
   <label class="label">Priority</label>
  <p class="control">
   <div class="select">  <PrioritySelect :list=activityPrioritiesList></PrioritySelect>
     </div></p>
  </p>
  </div>
  
      <div class="field extra-space">
   <label class="label">Quality</label>
  <p class="control">
   <div class="select"><QualitySelect :list=activityQualitiesList></QualitySelect> </div></p>
  </p>
  </div>
  
      <div class="field extra-space">
   <label class="label">Download</label>
  <p class="control">
<button class="button is-dark" @click="DownloadActivityLog()">Download</button>
</p>
  </div>
  
</div>     
    -->



        <div v-for="activityItem in filteredActivityLog">
          <Activity :activity="activityItem"></Activity>
          <br>
        </div>




      </div>
    </section>
  </div>
</template>

<script>
import Excel from 'exceljs/dist/es5/exceljs.browser';
import _ from 'lodash';
import moment from 'moment';
import ClientsSelect from '@/components/NavigatorActivityDownloader/ClientsSelect.vue'
import CreatedSelect from '@/components/NavigatorActivityDownloader/CreatedSelect.vue'
import AssignedSelect from '@/components/NavigatorActivityDownloader/AssignedSelect.vue'
import QualitySelect from '@/components/NavigatorActivityDownloader/QualitySelect.vue'
import PrioritySelect from '@/components/NavigatorActivityDownloader/PrioritySelect.vue'
import StatusSelect from '@/components/NavigatorActivityDownloader/StatusSelect.vue'
import Activity from '@/components/NavigatorActivityDownloader/Activity.vue'
import NavbarComponent from '@/components/NavbarComponent.vue'

export default {
  name: 'NavigatorActivityDownloader',
  props: {
  },
  components: {Activity, ClientsSelect,CreatedSelect,AssignedSelect, QualitySelect, PrioritySelect, StatusSelect, NavbarComponent},
  data: function() {return {
    navigatorUsername: this.$store.getters.navigatorUsername,
    navigatorPassword: this.$store.getters.navigatorPassword,
    navigatorUserId: this.$store.getters.navigatorUserId,
    loading: false,
    message: '',
    proxyurl: this.$store.getters.proxyurl,  
    activityLog: [],
    selectedPriority: "All", 
    selectedQuality: "All", 
    selectedCreated: "All", 
    selectedAssigned: "All", 
    selectedClient: "All", 
    selectedStatus: "All", 
        
    }
  },
  computed: {
  filteredActivityLog : function(){
    let tempActivityLog = this.activityLog;
    if (this.selectedClient != "All"){
    tempActivityLog = tempActivityLog.filter(activity => activity.clientName == this.selectedClient);
    }
    if (this.selectedPriority != "All"){
    tempActivityLog = tempActivityLog.filter(activity => activity.priority == this.selectedPriority);
    }
    if (this.selectedQuality != "All"){
    tempActivityLog = tempActivityLog.filter(activity => activity.activityQuality.name == this.selectedQuality);
    }
    if (this.selectedStatus != "All"){
    tempActivityLog = tempActivityLog.filter(activity => activity.status.name == this.selectedStatus);
    }
    if (this.selectedAssigned != "All"){
    if (this.selectedAssigned == null){
        tempActivityLog = tempActivityLog.filter(activity => activity.assignedTo == null)
        } else {
    tempActivityLog = tempActivityLog.filter(activity => activity.assignedTo.nameFirst + " " + activity.assignedTo.nameLast == this.selectedAssigned);
    }
    }
    if (this.selectedCreated!= "All"){
    if (this.selectedCreated == null){
        tempActivityLog = tempActivityLog.filter(activity => activity.createdBy == null)
        } else {
    tempActivityLog = tempActivityLog.filter(activity => activity.createdBy.nameFirst + " " + activity.createdBy.nameLast == this.selectedCreated);
    }
    }
    
    
    
    return _.orderBy(tempActivityLog,'createdAt','desc');//return filtered activity log sorted by createdAt newest first 
    },
    
    clientFilteredActivityLog : function(){
    let tempActivityLog = this.activityLog;
    if (this.selectedClient != "All"){
    tempActivityLog = tempActivityLog.filter(activity => activity.clientName == this.selectedClient);
    }  
    return tempActivityLog;
    },
  activityClientsList: function(){
  return _.sortBy(this.activityLog.map(activity => activity.clientName).filter((v, i, a) => a.indexOf(v) === i)) //get unique  and sort 
  },
  activityAssignedList: function(){
  return _.sortBy(this.clientFilteredActivityLog.map(function(activity){
  if (activity.assignedTo == null ){
  return "None" 
    }
    else{
    return activity.assignedTo.nameFirst + " " + activity.assignedTo.nameLast; 
    }
   }).filter((v, i, a) => a.indexOf(v) === i)) // get unique and sort 
  },
  activityCreatedList: function(){
 return _.sortBy(this.clientFilteredActivityLog.map(function(activity){
  if (activity.createdBy == null ){
  return "None" 
    }
    else{
    return activity.createdBy.nameFirst + " " + activity.createdBy.nameLast; 
    }
   }).filter((v, i, a) => a.indexOf(v) === i)) // get unique and sort 
  },
  
    activityPrioritiesList: function(){
  return _.sortBy(this.clientFilteredActivityLog.map(activity => activity.priority).filter((v, i, a) => a.indexOf(v) === i)) //get unique 
  },
  activityStatusesList: function(){
  return _.sortBy(this.clientFilteredActivityLog.map(activity => activity.status.name).filter((v, i, a) => a.indexOf(v) === i)) //get unique 
  },
  activityQualitiesList: function(){
  return _.sortBy(this.clientFilteredActivityLog.map(activity => activity.activityQuality.name).filter((v, i, a) => a.indexOf(v) === i)) //get unique 
  },
  
  },
  
  methods: {
  //convert unix time to date time
  convertunixtodatetime(timestamp){
  return moment.unix(parseInt(timestamp)/1000).format("DD/MM/YYYY HH:mm:ss Z");
  },
  

   strip(html)
{
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
},
  
  getActivityLog(){
  this.loading=true;
  let url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/activities/";
  this.$axios(
    {method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
     }).then((response) => {
      this.activityLog = response.data
      this.loading=false;
  
    }).catch((error) => {
    this.activityLog = {};
      this.loading=false;
    });
  },
  getActivityPriorities(){
    this.loading=true;
  let url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/activitypriorities/";
  this.$axios(
    {method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
     }).then((response) => {
      this.activityPrioritiesList = response.data.map(item => item.name);
      this.loading=false;
  
    }).catch((error) => {
    this.activityPrioritiesList = ["All"];
      this.loading=false;
    });
  
  },
  getActivityStatuses(){
    this.loading=true;
  let url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/activitystatuses/";
  this.$axios(
    {method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
     }).then((response) => {
      this.activityStatusesList = response.data.map(item => item.name);
      this.loading=false;
  
    }).catch((error) => {
    this.activityPrioritiesList = ["All"];
      this.loading=false;
    });
  },
  getActivityQualities(){
      this.loading=true;
  let url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/activityqualities/";
  this.$axios(
    {method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
     }).then((response) => {
      this.activityQualitiesList = response.data.map(item => item.name);
      this.loading=false;
  
    }).catch((error) => {
    this.activityPrioritiesList = [];
      this.loading=false;
    });
  
  },
  
  //Function to download activity log filtered into xlsx file 
  async DownloadActivityLog(){
  
  this.loading=true;
  var workbook = new Excel.Workbook(); //create workbook
  var sheet = workbook.addWorksheet("Activities"); //add worksheet
  var worksheet = workbook.getWorksheet("Activities");
  worksheet.columns =[
  {header: 'Client', width: 15},
    {header: 'Status', width: 8},
      {header: 'Quality', width: 15},
        {header: 'Created At', width: 15},
          {header: 'Priority', width: 15},
            {header: 'Assigned To', width: 15},
              {header: 'Created By', width: 15},
                {header: 'Name', width: 20},
                  {header: 'nodeName', width: 15},
                    {header: 'Description', width: 50},
                      {header: 'Comments', width: 50},
                 {header: 'Actions Taken', width: 50},
                      {header: 'Root Causes', width: 50},                      
                 {header: 'Cost', width: 10},
                      {header: 'One Year Cost Avoidance', width: 25},  ];
                      
   let temporaryActivityLogToDownload = this.filteredActivityLog;
   for (var i = 0; i < temporaryActivityLogToDownload.length; i++){
   var row = []
   let activity = temporaryActivityLogToDownload[i];
   row.push(activity.clientName);
   row.push(activity.status.name);
   row.push(activity.activityQuality.name);
   row.push(this.convertunixtodatetime(activity.createdAt));
   row.push(activity.priority);
   
   if (activity.assignedTo == null){
    row.push("");
    }else{
    row.push(activity.assignedTo.nameFirst + " " + activity.assignedTo.nameLast)
    }
    
       if (activity.createdBy == null){
    row.push("");
    }else{
    row.push(activity.createdBy.nameFirst + " " + activity.createdBy.nameLast)
    }
 
      row.push(activity.name);
         row.push(activity.nodeName);
            row.push(this.strip(activity.description));
           
           //combine comments, actions and root causes requests into a single promise (to request at same time), then process the data 
           let PromiseArray = [];
           let urlComments = this.proxyurl + "https://eadvantage.siemens.com/remote/release" + activity.commentsReference;
             let urlActions = this.proxyurl + "https://eadvantage.siemens.com/remote/release" + activity.actionsTakenReference; 
            let urlRootCauses = this.proxyurl + "https://eadvantage.siemens.com/remote/release" + activity.rootCausesReference;
             
           PromiseArray.push(this.$axios({method: 'get',url: urlComments,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}));
           PromiseArray.push(this.$axios({method: 'get',url: urlActions,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}));
 PromiseArray.push(this.$axios({method: 'get',url: urlRootCauses,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}}));

 await this.$axios.all(PromiseArray)
 .then((responseArray) => {
       let commentsdataArray = responseArray[0].data;
      let comments_to_write = "";
        commentsdataArray.forEach(comment =>{
         let name = comment.user.nameFirst + ' ' + comment.user.nameLast;
         let comment_date = this.convertunixtodatetime(comment.createDate)
         let commentContent = this.strip(comment.comment)
         comments_to_write = comments_to_write + comment_date + " " + name + ":\n" + commentContent + "\n"
        });
         row.push(comments_to_write);    

        let actionsdataArray = responseArray[1].data; 
        let actions_to_write = ""
        actionsdataArray.forEach(action =>{
       
            let workorders = action.workOrder
            let actions = action.action
            actions_to_write = actions_to_write + workorders + ' ' + actions + "\n"
   
        });
         row.push(actions_to_write);       
           
        let rootcauses_to_write  = "";
        let rootcausesdataArray = responseArray[2].data; 
        rootcausesdataArray.forEach(rootcause =>{
       
        let rootcauses = rootcause.rootCause
            rootcauses_to_write = rootcauses + "\n"
     
        });
        row.push(rootcauses_to_write );    
        }).catch(function(error) {
                console.log(error.message);
            });

     row.push(activity.cost);
      row.push(activity.oneYearAvoidedCost);
           
   
     worksheet.addRow(row);
   }

   //set cells in range to wrapText is true 
   
   worksheet.eachRow(function(row, rowNumber){ //iterate through all non empty rows
        row.eachCell(function(cell, colNumber){ //iterate througha all non empty  cells
        cell.alignment = {vertical: 'top', wrapText: true};
        });
   });





   //write workbook to file 

    workbook.xlsx.writeBuffer( {
                base64: true
            })
            .then( function (xls64) {
                // build anchor tag and attach file (works in chrome)
                var a = document.createElement("a");
                var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

                var url = URL.createObjectURL(data);
                a.href = url;
                a.download = "ActivityLog.xlsx";
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    },
                    0);
            })
            .catch(function(error) {
                console.log(error.message);
            });
   
   
   
  this.loading=false;
 return console.log("Downloaded Activity Log");

  }
  
  
  },
  mounted() {
  this.getActivityLog();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>.select {
  margin-bottom: -28px;
  margin-top: 3px;

}


    .button.is-primary {
       background-color:#000028;
        color:white;
        }       
       
       .button.is-primary:hover{
         background-color:#000028;
           color:white;
       }
       
       
       

       .button.is-primary:active{
         background-color:#002949;
           color:white;
       }

</style>
